module.exports = __webpack_public_path__ + "img/img_thumbnail_percubaan.1d855948.png";